(function($) {
	'use strict';
	$.widget('msv.dynamicForm', {
		el: {},
		_create: function() {
			var self = this;
			self.vars = {};
			self.vars.htmlToClone = self.element[0].innerHTML;
		},
		_init: function() {
			var self = this;
			self.el.addButton = self.element.find('.js-button-add');

			self.el.addButton
				.off('click')
				.click(function(e) {

					var currentRowHtml = $(e.target).parent();
					var newRemoveButton = $('<a class="btn-remove js-button-remove"></a>');

					newRemoveButton.off('click').click(function(e) {
						currentRowHtml.remove();
					});

					var newRow = $(self.vars.htmlToClone);
					newRow.find(".js-dropdown").dropdown();
					newRow.find(".js-dropdown-search").dropdownSearch();
					$(this).before(newRemoveButton); //add remove button before add button;
					self.element.append(newRow);
					self.element.dynamicForm();
					e.target.remove(); //remove add button                
				});
		},
		_destroy: function() {}
	});
})(jQuery);